import { Conditional, Else, If } from "@hex-insights/core";
import { Redirect, Route, useActivePageRegistration } from "@hex-insights/router";
import { useReEnrollmentPaymentPlanContractListQuery } from "@hex-insights/verita-romania.shared";
import { PageRouteSwitch } from "../../../Components";
import { ReEnrollmentLayout } from "../Components";
import { reEnrollmentMealPlansPageInfo } from "../MealPlansPage/pageinfo";
import { getReEnrollmentContractFilter } from "../Utilities";
import { ReEnrollmentPaymentPlansDefinitionSelectionPage } from "./DefinitionSelectionPage";
import { reEnrollmentPaymentPlansDefinitionSelectionPageInfo } from "./DefinitionSelectionPage/pageinfo";
import { ReEnrollmentPaymentPlansGroupedPage } from "./GroupedPage";
import { reEnrollmentPaymentPlansGroupedPageInfo } from "./GroupedPage/pageinfo";
import { ReEnrollmentPaymentPlansIndividualPage } from "./IndividualPage";
import { reEnrollmentPaymentPlansIndividualPageInfo } from "./IndividualPage/pageinfo";
import { reEnrollmentPaymentPlansPageInfo } from "./pageinfo";

export function ReEnrollmentPaymentPlansPage() {
	useActivePageRegistration(reEnrollmentPaymentPlansPageInfo);

	const { data } = useReEnrollmentPaymentPlanContractListQuery({
		variables: {
			filters: getReEnrollmentContractFilter(),
		},
		fetchPolicy: "network-only",
	});
	const numContracts = data?.contractConnection.edges.length ?? 0;

	if (!data) {
		return <ReEnrollmentLayout>Loading...</ReEnrollmentLayout>;
	}

	const formPageBackTo =
		numContracts > 1 ? reEnrollmentPaymentPlansDefinitionSelectionPageInfo.to : reEnrollmentMealPlansPageInfo.to;

	return (
		<PageRouteSwitch>
			<Route {...reEnrollmentPaymentPlansDefinitionSelectionPageInfo}>
				<Conditional>
					<If condition={numContracts === 1}>
						<Redirect to={reEnrollmentPaymentPlansIndividualPageInfo.to} />
					</If>
					<Else>
						<ReEnrollmentPaymentPlansDefinitionSelectionPage />
					</Else>
				</Conditional>
			</Route>
			<Route {...reEnrollmentPaymentPlansIndividualPageInfo}>
				<ReEnrollmentPaymentPlansIndividualPage data={data} backTo={formPageBackTo} />
			</Route>
			<Route {...reEnrollmentPaymentPlansGroupedPageInfo}>
				<ReEnrollmentPaymentPlansGroupedPage data={data} backTo={formPageBackTo} />
			</Route>
		</PageRouteSwitch>
	);
}
